// @flow
import { TiposActionTypes } from './constants';

const INIT_STATE = {
    tipo: {},
    listaTipos: [],
    loading: false,
    error: false,
    formSubmited: false
};

type TiposAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { tipo?: {} | null, listaTipos?: [] | null, loading?: boolean, +value ?: boolean };

const Tipos = (state: State = INIT_STATE, action: TiposAction): any => {
    // console.tipo(action);
    switch (action.type) {
        case TiposActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TiposActionTypes.LIST_TIPOS: {
                    return {
                        ...state,
                        listaTipos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TiposActionTypes.GET_TIPO: {
                    return {
                        ...state,
                        tipo: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TiposActionTypes.ADD_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposActionTypes.UPDATE_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposActionTypes.DELETE_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TiposActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TiposActionTypes.LIST_TIPOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaTipos: [],
                        loading: false,
                    };
                }
                case TiposActionTypes.GET_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        tipo: {},
                        loading: false,
                    };
                }
                case TiposActionTypes.ADD_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposActionTypes.UPDATE_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposActionTypes.DELETE_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TiposActionTypes.LIST_TIPOS:
            return { ...state, error: false, loading: true };
        case TiposActionTypes.GET_TIPO:
            return { ...state, error: false, loading: true };
        case TiposActionTypes.ADD_TIPO:
            return { ...state, error: false, loading: true };
        case TiposActionTypes.UPDATE_TIPO:
            return { ...state, error: false, loading: true };
        case TiposActionTypes.DELETE_TIPO:
            return { ...state, error: false, loading: false };
        case TiposActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                tipo: {},
                listaTipos: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Tipos;
